import { openModal } from '@core/components/ModalStack';
import { PageStatsOverlayProps } from './PageStatsOverlay';

export async function openPageStatsOverlay(props: PageStatsOverlayProps) {
  const { PageStatsOverlay } = await import('./PageStatsOverlay');

  openModal(PageStatsOverlay, props);
}
